module.exports = __webpack_public_path__ + "static/media/illu_expert-attente.80d03097.svg";